import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Row, Col, Table } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ViewManager } from '../../../core/view-manager';
import FormEntityInstanceCompiler from '../../../components/Entity/FormEntityInstanceCompiler';


export default function ModalEntityCompiler({ entity = null, confirmCallback, initData={}, excludedFields=[], status, close }) {

    useEffect(() => {
        if(entity !== null) {
            
        }
    }, [entity]);


    function closeModal() {
        close()
    }

    function save(data) {
        confirmCallback(data)
    }


    if(status !== false && entity !== null) { 
        return (
            <>
                <Modal show={status} onHide={closeModal} size="xl" scrollable={true} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{LanguageProvider.get('entity.'+entity)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormEntityInstanceCompiler entity={entity} confirmCallback={save} initData={initData} excludedFields={excludedFields} />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
};